import { esc } from '../lib/helpers.js';
import { initLightbox, initPhotoStrips } from '../lib/gallery.js';

// Init gallery (shared lightbox + photo strips)
initLightbox();
initPhotoStrips();

// ── Sponsor slot loader ──
(function () {
  var data = window.__PAGE_DATA;
  if (!data) return;

  var KEY = data.serviceId + ':' + data.citySlug;
  var SVC_NAME = data.svcName;
  var CITY_NAME = data.cityName;
  var STATE_ABBR = data.stateAbbr;
  var INQUIRY_URL = data.inquiryUrl;
  var PAYMENT_URL = data.paymentUrl;
  var PRICE = data.price;
  var API_URL = data.apiUrl;
  var R2_PUBLIC_URL = data.r2PublicUrl;

  function stars(r) {
    if (!r) return '';
    var full = Math.floor(r), half = (r - full) >= 0.5 ? 1 : 0, empty = 5 - full - half;
    return '\u2605'.repeat(full) + (half ? '\u00BD' : '') + '\u2606'.repeat(empty);
  }

  function yelpStars(r) {
    if (!r) return '';
    var v = Math.round(parseFloat(r) * 2) / 2;
    v = Math.max(0, Math.min(5, v));
    var key = (v === Math.floor(v)) ? String(Math.floor(v)) : Math.floor(v) + '_5';
    return '<img src="' + R2_PUBLIC_URL + '/yelp/stars_' + key + '.png" alt="' + v + ' stars" height="16" style="height:16px;width:auto;display:inline-block;vertical-align:middle">';
  }

  function buildCard(s) {
    var nameHtml = s.biz_slug
      ? '<a href="/biz/' + esc(s.biz_slug) + '/" class="hover:text-blue-600 transition-colors">' + esc(s.name) + '</a>'
      : esc(s.name);

    var logoHtml = s.logo_url
      ? '<img src="' + esc(s.logo_url) + '" alt="" class="w-10 h-10 object-contain rounded-lg border border-slate-100 bg-white p-0.5 flex-shrink-0">'
      : s.name
        ? '<div class="w-10 h-10 rounded-lg bg-amber-500 flex items-center justify-center text-white text-sm font-bold flex-shrink-0 select-none">' + esc(s.name.slice(0, 2).toUpperCase()) + '</div>'
        : '';

    var ratingHtml = '';
    if (s.rating) {
      ratingHtml += '<div class="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-lg px-2.5 py-1.5">'
        + '<span class="text-xs font-semibold text-blue-600 flex-shrink-0">Google</span>'
        + '<span class="w-px h-3 bg-blue-200 flex-shrink-0"></span>'
        + '<span class="text-amber-400 leading-none text-sm">' + stars(s.rating) + '</span>'
        + '<span class="font-bold text-sm text-slate-800">' + esc(s.rating) + '</span>'
        + '<span class="text-xs text-slate-400 whitespace-nowrap">' + (s.review_count || 0) + ' reviews</span>'
        + '</div>';
    }
    if (s.yelp_rating) {
      ratingHtml += '<div class="inline-flex items-center gap-2 bg-red-50 border border-red-100 rounded-lg px-2.5 py-1.5">'
        + '<span class="text-xs font-semibold text-red-600 flex-shrink-0">Yelp</span>'
        + '<span class="w-px h-3 bg-red-200 flex-shrink-0"></span>'
        + yelpStars(s.yelp_rating)
        + '<span class="font-bold text-sm text-slate-800">' + esc(s.yelp_rating) + '</span>'
        + '<span class="text-xs text-slate-400 whitespace-nowrap">' + (s.yelp_review_count || 0) + ' reviews</span>'
        + '</div>';
    }

    var btns = '';
    if (s.phone) {
      var d = s.phone.replace(/\D/g, '');
      btns += '<a href="tel:' + esc(d) + '" class="inline-flex items-center gap-1.5 text-xs font-medium bg-slate-900 text-white rounded-lg px-3 py-1.5 w-full justify-center sm:w-28">\uD83D\uDCDE ' + esc(s.phone) + '</a>';
    }
    if (s.website) {
      btns += '<a href="' + esc(s.website) + '" target="_blank" rel="noopener" class="inline-flex items-center gap-1.5 text-xs font-medium bg-white border border-slate-200 text-slate-700 rounded-lg px-3 py-1.5 hover:border-slate-300 w-full justify-center sm:w-28">\uD83C\uDF10 Website</a>';
    }
    if (s.biz_slug) {
      btns += '<a href="/biz/' + esc(s.biz_slug) + '/" class="inline-flex items-center justify-center text-xs font-medium text-blue-600 hover:text-blue-800 hover:underline w-full sm:w-28">View profile \u2192</a>';
    }

    var clickAttr = s.biz_slug
      ? ' onclick="if(!event.target.closest(\'a,button\'))window.location=\'/biz/' + esc(s.biz_slug) + '/\'"'
      : '';
    return '<div class="relative bg-white border-2 border-amber-300 rounded-xl p-5 shadow-sm' + (s.biz_slug ? ' cursor-pointer' : '') + '"'
      + clickAttr + '>'
      + '<div class="absolute top-3 right-3">'
      + '<span class="text-xs font-semibold bg-amber-100 text-amber-700 rounded-full px-2.5 py-0.5 border border-amber-200">' + esc(s.label || 'Sponsored') + '</span>'
      + '</div>'
      + '<div class="flex gap-4">'
      + (logoHtml ? '<div class="flex-shrink-0 pt-0.5">' + logoHtml + '</div>' : '')
      + '<div class="flex-1 min-w-0 flex flex-col sm:flex-row gap-4">'
      + '<div class="flex-1 min-w-0">'
      + '<h2 class="text-base font-semibold text-slate-900 leading-snug mb-1.5 pr-20">' + nameHtml + '</h2>'
      + (ratingHtml ? '<div class="flex flex-wrap gap-2 mb-2">' + ratingHtml + '</div>' : '')
      + (s.address ? '<p class="text-sm text-slate-500 mb-1"><a href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.address) + '" target="_blank" rel="noopener" class="hover:text-blue-600 transition-colors">\uD83D\uDCCD ' + esc(s.address) + '</a></p>' : '')
      + '</div>'
      + (btns ? '<div class="flex-shrink-0 flex flex-col items-stretch gap-2 sm:w-28">' + btns + '</div>' : '')
      + '</div>'
      + '</div>'
      + '</div>';
  }

  function buildPlaceholder() {
    var href;
    if (PAYMENT_URL) {
      href = '/sponsor/?slot=' + encodeURIComponent(KEY);
    } else if (INQUIRY_URL) {
      var subject = encodeURIComponent('Featured placement: ' + SVC_NAME + ' in ' + CITY_NAME + ', ' + STATE_ABBR);
      href = INQUIRY_URL.indexOf('mailto:') === 0
        ? INQUIRY_URL + '?subject=' + subject
        : INQUIRY_URL;
    } else {
      return null;
    }
    var priceHtml = PRICE
      ? '<span class="text-xs text-slate-400">\u00B7 ' + esc(PRICE) + '</span>'
      : '';
    return '<a href="' + esc(href) + '" class="group block relative border-2 border-dashed border-amber-300 rounded-xl p-5 bg-amber-50/40 hover:bg-amber-50 hover:border-amber-400 hover:shadow-md transition-all duration-200 cursor-pointer no-underline">'
      + '<div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">'
      + '<div class="flex-1 min-w-0">'
      + '<div class="flex items-center gap-2 mb-1">'
      + '<span class="text-xs font-semibold bg-amber-100 text-amber-700 rounded-full px-2.5 py-0.5 border border-amber-200">Sponsored</span>'
      + '<span class="text-xs text-slate-400">\u00B7 Available</span>'
      + priceHtml
      + '</div>'
      + '<p class="text-sm font-semibold text-slate-800 mb-0.5 group-hover:text-amber-900 transition-colors">Advertise your ' + esc(SVC_NAME.toLowerCase()) + ' business here</p>'
      + '<p class="text-xs text-slate-500">Be the first business customers see when searching for '
      + esc(SVC_NAME.toLowerCase()) + 's in ' + esc(CITY_NAME) + ', ' + esc(STATE_ABBR) + '. '
      + 'Your business appears above all organic results.</p>'
      + '</div>'
      + '<span class="flex-shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold bg-amber-400 group-hover:bg-amber-500 text-amber-900 rounded-lg px-4 py-2 transition-colors whitespace-nowrap">'
      + 'Get this spot &rarr;</span>'
      + '</div>'
      + '</a>';
  }

  function showSlot(sponsor) {
    var slot = document.getElementById('sponsored-slot');
    if (!slot) return;
    if (sponsor && sponsor.active !== false) {
      slot.innerHTML = buildCard(sponsor);
      slot.style.display = 'block';
    } else {
      var ph = buildPlaceholder();
      if (ph) { slot.innerHTML = ph; slot.style.display = 'block'; }
    }
  }

  if (API_URL) {
    fetch(API_URL + '/sponsors?key=' + encodeURIComponent(KEY))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(showSlot)
      .catch(function (e) { console.warn('Sponsor API fetch failed:', e); });
  } else {
    fetch('/data/sponsors.json', { cache: 'no-cache' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { showSlot(data && data[KEY] ? data[KEY] : null); })
      .catch(function (e) { console.warn('Sponsor data fetch failed:', e); });
  }
})();
